import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { flyoutTransition } from '../config';
import styled from 'styled-components';
import FocusLock from 'react-focus-lock';
const opacityVariant = {
    initial: {
        opacity: 0,
        transition: Object.assign({}, flyoutTransition),
    },
    animate: {
        opacity: 1,
        transition: Object.assign({}, flyoutTransition),
    },
    exit: {
        opacity: 0,
        transition: Object.assign({}, flyoutTransition),
    },
};
const InvertedDark = styled(motion.div).attrs({
    className: 'encore-inverted-dark-set',
}) `
  background-color: var(--background-base);
`;
export const FlyoutMenuContainer = ({ children, contentKey, onClose, }) => {
    return (React.createElement(InvertedDark, { key: "flyoutcontent", layout: true, transition: flyoutTransition, onMouseLeave: onClose, style: { overflow: 'hidden' } },
        React.createElement(AnimatePresence, { mode: "popLayout" },
            React.createElement(motion.div, { key: contentKey + new Date(), layout: true, layoutRoot: true, initial: "initial", animate: "animate", exit: "exit", variants: opacityVariant, "data-testid": contentKey },
                React.createElement(FocusLock, { returnFocus: true, autoFocus: false }, children)))));
};
//# sourceMappingURL=FlyoutMenuContainer.js.map